import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { APPCONFIG } from '../../../config';
import {Api} from '../../../providers/api'

@Component({
  selector: 'my-app-sidenav-menu',
  styles: [],
  template: require('./sidenav-menu.component.html')
})

export class AppSidenavMenuComponent {

	listGroups = [
		// {
		// 	name:"Tax Group",
		// 	alias:"taxGroup",
		// 	icon:"format_list_bulleted"
		// },
		{
			name:"Customer Group",
			alias:"customerGroup",
			icon:"format_list_bulleted"
		},
		{
			name:"Payment term",
			alias:"termsCode",
			icon:"format_list_bulleted"
		},
		{
			name:"Bad Product Conditions",
			alias:"badProductConditions",
			icon:"format_list_bulleted"
		},

		{
			name:"Shipping Services",
			alias:"shippingServices",
			icon:"format_list_bulleted"
		}
		// {
		// 	name:"Country",
		// 	alias:"country",
		// 	icon:"format_list_bulleted"
		// }
]

	constructor(private router:Router, public api: Api){
		localStorage.setItem("allowedTables",JSON.stringify(this.listGroups));
	}

	logout(){
		localStorage.removeItem(APPCONFIG.prefix+'isLoggedIn');
		this.router.navigate(['/extra/login']);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/layout/sidenav/sidenav-menu/sidenav-menu.component.ts